export class MateriaComentario {
    id: number;
    idMateria: number;
    comentario: string;
    nome: string;
    email: string;
    data: Date;
  }